/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import * as XLSX from 'xlsx';

import Button from 'material-ui/Button';

import {
  ValidatorForm,
  SelectValidator,
} from 'react-material-ui-form-validator';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import MenuItem from 'material-ui/Menu/MenuItem';

import 'react-infinite-calendar/styles.css';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import { withRouter } from 'react-router';

import moment from 'moment';

import {
  setExportProdStartDate,
  setExportProdEndDate,
  getProducingDataForExport,
  setLoadingExportProdData,
  reportOrganizationChanged,
  reportUnitChanged,
  getOrganizations,
} from '../actions';
import { translate } from 'react-i18next';
import {
  checkUserIsAdmin,
  checkUserIsSuperAdmin,
} from '../utils/user/checkAdmin/CheckAdmin';

import LoadingCircle from './commons/LoadingCircle';

const styles = theme => ({
  tableWrapper: {
    overflowX: 'auto',
  },
});

class Report extends React.Component {
  componentDidMount = async () => {
    const { isAuthenticated, user } = this.props;

    let isSuperAdmin = checkUserIsSuperAdmin(isAuthenticated, user);
    let isAdmin = checkUserIsAdmin(isAuthenticated, user);

    if (isSuperAdmin) {
      await this.props.getOrganizations();
      this.props.reportOrganizationChanged('');
    } else if (isAdmin) {
      let userOrganizationId = user.user_metadata.organization._id;
      this.props.reportOrganizationChanged(userOrganizationId);
      await this.props.getOrganizations();
    } else {
      this.props.history.push('/');
    }
  };

  handleReportUnitChange = () => event => {
    this.props.reportUnitChanged(event.target.value);
  };

  handleReportOrganizationChange = () => event => {
    this.props.reportOrganizationChanged(event.target.value);
  };

  handleSubmitFormExportProd = async () => {
    let reportUnit = this.props.reportUnit;
    this.props.setLoadingExportProdData(true);
    let producingDataForExport = await this.props.getProducingDataForExport(
      this.props.exportProdStartDate,
      this.props.exportProdEndDate,
      this.props.reportOrganizationId
    );
    this.props.setLoadingExportProdData(false);

    let months = producingDataForExport.months;
    let utilities = producingDataForExport.utilities;
    let lines = [];

    lines.push([
      'This report is generated by Attributes (attributes.digital) on ' +
        moment().toDate(),
    ]);
    lines.push([
      'The quantites mentioned in this file are the minimum quantites in' +
        reportUnit +
        ' to use for GO cancellation',
    ]);
    lines.push([
      'Should you have any questions or require additional information regarding the use of this data, please contact Attributes team : contact@attributes.digital',
    ]);
    lines.push([['']]);

    utilities.map(utiliy => {
      utiliy.customers.map(customer => {
        let utilityWithCustomerLine = [utiliy.name, customer.name];
        lines.push(utilityWithCustomerLine);

        let assetsNameLine = ['', reportUnit];
        customer.assets.map(asset => {
          assetsNameLine.push(asset.asset.displayedName);
        });
        assetsNameLine.push('Total');
        assetsNameLine.push('Consumption');
        assetsNameLine.push('Matching rate');
        lines.push(assetsNameLine);

        months.map((month, index) => {
          let monthlyValues = ['', month];
          let monthlyTotal = 0;

          customer.assets.map(asset => {
            reportUnit === 'MWh'
              ? (monthlyTotal += asset.quantities.matchedProduction[index])
              : (monthlyTotal += asset.quantities.matchedProduction[index]
                  ? asset.quantities.matchedProduction[index] * 1000
                  : 0);
            reportUnit === 'MWh'
              ? monthlyValues.push(
                  Math.ceil(asset.quantities.matchedProduction[index])
                )
              : asset.quantities.matchedProduction[index]
              ? monthlyValues.push(
                  Math.ceil(asset.quantities.matchedProduction[index] * 1000)
                )
              : monthlyValues.push(0);
          });
          monthlyValues.push(Math.ceil(monthlyTotal));
          reportUnit === 'MWh'
            ? monthlyValues.push(Math.ceil(customer.consumption[index]))
            : customer.consumption[index]
            ? monthlyValues.push(Math.ceil(customer.consumption[index] * 1000))
            : 0;
          let percentageMWh = customer.consumption[index]
            ? Math.round((100 * monthlyTotal) / customer.consumption[index])
            : '-';
          let percentagekWh = customer.consumption[index]
            ? Math.round(
                (100 * monthlyTotal) / (customer.consumption[index] * 1000)
              )
            : '-';
          let percentage = reportUnit === 'MWh' ? percentageMWh : percentagekWh;
          monthlyValues.push(percentage);

          lines.push(monthlyValues);
        });

        lines.push([['']]);
      });
    });

    if (lines && lines.length > 0) {
      /* generate worksheet */
      const ws = XLSX.utils.aoa_to_sheet(lines);

      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, 'attributes-prod-export.xlsx');
    }
  };

  renderExportProdDataForm() {
    const {
      classes,
      t,
      utilityOrganizations,
      isAuthenticated,
      user,
    } = this.props;
    let isSuperAdmin = checkUserIsSuperAdmin(isAuthenticated, user);

    return (
      <div>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader title={t('Export monthly energy production data')} />
          <CardContent>
            <Grid item xs={12}>
              <ValidatorForm
                ref="form-export-prod"
                onSubmit={async () => {
                  await this.handleSubmitFormExportProd();
                }}
                onError={errors => console.log(errors)}
                className={classNames(classes.margin, classes.textField)}
                style={{ marginLeft: 8 }}
              >
                <Row>
                  <Col xs={12}>
                    <Row style={{ marginTop: 20 }}>
                      <div
                        style={{
                          marginTop: 20,
                          marginRight: 20,
                          float: 'left',
                        }}
                      >
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('Between')}
                        </Typography>
                      </div>
                      <div style={{ marginRight: 15, float: 'left' }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            format="dd/MM/yyyy"
                            openTo={'year'}
                            id="maintenance-export-prod-start-date"
                            label={t('Start date')}
                            value={this.props.exportProdStartDate}
                            onChange={newDate => {
                              if (!moment(newDate).isValid() || !newDate) {
                                newDate = null;
                              }

                              this.props.setExportProdStartDate(newDate);
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            className={classes.inputWithMargin}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div style={{ marginRight: 15, float: 'left' }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            format="dd/MM/yyyy"
                            openTo={'year'}
                            id="maintenance-export-prod-end-date"
                            label={t('End date')}
                            value={this.props.exportProdEndDate}
                            onChange={newDate => {
                              if (!moment(newDate).isValid() || !newDate) {
                                newDate = null;
                              }

                              this.props.setExportProdEndDate(newDate);
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            className={classes.inputWithMargin}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </Row>

                    {isSuperAdmin && (
                      <Row>
                        <div style={{ marginTop: 39, marginRight: 20 }}>
                          <Typography
                            variant="caption"
                            style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                          >
                            {t('For')}
                          </Typography>
                        </div>
                        <SelectValidator
                          style={{ width: 300 }}
                          id="select-organization"
                          label={t('Select organization')}
                          className={classes.textField}
                          value={
                            this.props.reportOrganizationId
                              ? this.props.reportOrganizationId
                              : ''
                          }
                          validators={[]}
                          errorMessages={[]}
                          onChange={this.handleReportOrganizationChange()}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {
                            <MenuItem key="" value="">
                              {t('All (fem)')}
                            </MenuItem>
                          }
                          {utilityOrganizations.map(organization => (
                            <MenuItem
                              key={organization._id}
                              value={organization._id}
                            >
                              {organization.name}
                            </MenuItem>
                          ))}
                        </SelectValidator>
                      </Row>
                    )}

                    <Row>
                      <div style={{ marginTop: 39, marginRight: 20 }}>
                        <Typography
                          variant="caption"
                          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                        >
                          {t('Unit')}
                        </Typography>
                      </div>
                      <SelectValidator
                        style={{ width: 300 }}
                        id="select-unit"
                        label={t('Select report unit')}
                        className={classes.textField}
                        value={
                          this.props.reportUnit ? this.props.reportUnit : 'MWh'
                        }
                        onChange={this.handleReportUnitChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        <MenuItem key="MWh" value="MWh">
                          MWh
                        </MenuItem>
                        <MenuItem key="kWh" value="kWh">
                          kWh
                        </MenuItem>
                      </SelectValidator>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                      <Button
                        type="submit"
                        variant="raised"
                        color="primary"
                        onClick={() => {}}
                        disabled={
                          !this.props.exportProdStartDate ||
                          !this.props.exportProdEndDate ||
                          this.props.loadingExportProdData
                        }
                      >
                        {this.props.loadingExportProdData && (
                          <LoadingCircle
                            type="buttonProgressInside"
                            classes={classes}
                            color="#ffffff"
                          />
                        )}
                        {t('Export')}
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </ValidatorForm>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }

  render() {
    const { classes, loadingOrganizations, utilityOrganizations } = this.props;

    if (
      !utilityOrganizations ||
      utilityOrganizations.length < 1 ||
      loadingOrganizations
    ) {
      return <LoadingCircle type="buttonProgress" classes={classes} />;
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {this.renderExportProdDataForm()}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = ({
  loginReducer,
  maintenanceReducer,
  organizationsReducer,
}) => {
  const {
    loading,
    loadingExportProdData,
    exportProdStartDate,
    exportProdEndDate,
    reportOrganizationId,
    reportUnit,
  } = maintenanceReducer;

  const utilityOrganizations = organizationsReducer.utilityOrganizations;
  const loadingOrganizations = organizationsReducer.loading;

  const { isAuthenticated, user } = loginReducer;
  return {
    loading,
    loadingOrganizations,
    isAuthenticated,
    user,
    loadingExportProdData,
    exportProdStartDate,
    exportProdEndDate,
    utilityOrganizations,
    reportOrganizationId,
    reportUnit,
  };
};

const mapDispatchToProps = {
  setExportProdStartDate,
  setExportProdEndDate,
  getProducingDataForExport,
  setLoadingExportProdData,
  reportOrganizationChanged,
  reportUnitChanged,
  getOrganizations,
};

Report = withStyles(styles, { name: 'Report' })(Report);
Report = translate('translations')(Report);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Report)
);



// WEBPACK FOOTER //
// ./src/components/Report.js